import request from '../../axios';

const getCountries = async () => {
  const {data}: {data: ICountry[]} = await request.get(`api/v2/base/country`);
  return data;
};

export default getCountries;
